export const heading = "Chargeback Aging Report";
export const completeListLink = "quadreport1";
